import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.2",
      d: "M14.8 3.6q.04 0 .078.02.035.016.065.053l.032.049 2.39 4.173a.27.27 0 0 1-.004.27l-.04.053-6.792 7.949a.8.8 0 0 1-.243.173.7.7 0 0 1-.285.06H10a.72.72 0 0 1-.482-.193l-.073-.07-6.785-7.94v-.002a.274.274 0 0 1-.042-.267l.02-.041 2.4-4.188.018-.026.021-.023.033-.024.01-.007.018-.008.027-.008.007-.001.056-.002z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.2",
      d: "M7.372 6.81c.04.026.077.071.096.132a.27.27 0 0 1-.008.178l-.016.032-.173.305a.6.6 0 0 0 .067.691l1.201 1.383c.036.042.06.1.06.166.002.063-.02.12-.052.162l-.027.03a.18.18 0 0 1-.118.05.18.18 0 0 1-.118-.045l-.034-.036-1.589-1.83a.26.26 0 0 1-.057-.127.3.3 0 0 1 .013-.137l.027-.054.47-.821a.2.2 0 0 1 .123-.1.2.2 0 0 1 .068-.004z"
    }, null, -1)
  ])))
}
export default { render: render }